export const emailRegex =
	/^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/

export const matchUrl = /((?:www.)?[^\s.]+\.[^\s/]+\/[^\s.]+)/

export const reUnescapedHtml = /[&<>"']/g
